import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../themes/theme';
const ResponsiveSvg = styled.svg `
  min-width: 1.125rem;
  min-height: 1.125rem;
  width: 1.125rem;
  height: 1.125rem;

  ${media.tablet `
    min-width: 1.875rem;
    min-height: 1.875rem;
    width: 1.875rem;
    height: 1.875rem;
    ${props => props.isAssignment &&
    css `
        min-width: 1.5rem;
        min-height: 1.5rem;
        width: 1.5rem;
        height: 1.5rem;
      `}
  `}
`;
/** @deprecated Please use a suitable Wrapper like CardHeaderIcon, CardHeaderLink, CardHeaderButton with the Icon component instead, icon sizes need an update to match the requirements of our styleguide */
export function CardIconDelete() {
    return (React.createElement(ResponsiveSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M33.727 11.415c.886 0 1.564.677 1.564 1.563v27.364c0 .886-.678 1.563-1.564 1.563H8.397a1.536 1.536 0 0 1-1.564-1.563V12.978c0-.886.677-1.563 1.563-1.563h25.331zm-1.563 3.127H9.96v24.236h22.204V14.542zM15.85 19.389c.886 0 1.563.678 1.563 1.564v11.101c0 .886-.677 1.564-1.563 1.564a1.536 1.536 0 0 1-1.564-1.564V20.953c0-.887.678-1.564 1.564-1.564zm10.424 0c.886 0 1.563.678 1.563 1.564v11.101c0 .886-.677 1.564-1.563 1.564a1.536 1.536 0 0 1-1.564-1.564V20.953c0-.887.678-1.564 1.564-1.564zM24.867 0c1.772 0 3.127 1.355 3.127 3.127v1.877h8.496c.886 0 1.563.677 1.563 1.563 0 .886-.677 1.564-1.563 1.564H5.634a1.536 1.536 0 0 1-1.563-1.564c0-.886.677-1.563 1.563-1.563h8.496V3.127C14.13 1.355 15.485 0 17.257 0zm0 3.127h-7.61v1.877h7.61V3.127z" })));
}
/**
 * Helper for icon components based on SVG files
 */
export function createSvgIcon(rawSize = 'default', children) {
    let size;
    switch (rawSize) {
        case 'small':
            size = 16;
            break;
        case 'large':
            size = 42;
            break;
        case 'xlarge':
            size = 50;
            break;
        default:
            size = 30;
    }
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42", 
        // Use min-width + min-height to ensure the size even in flex parents
        style: { minWidth: size, minHeight: size, width: size, height: size } }, children));
}
export function IconAdd(props) {
    return createSvgIcon(props.size, React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21 0c11.596 0 21 9.398 21 21 0 11.596-9.407 21-21 21C9.405 42 0 32.593 0 21 0 9.405 9.398 0 21 0zm.151 10.07a1.08 1.08 0 0 0-1.08 1.08l-.006 8.93-8.893.006a1.08 1.08 0 0 0-1.079 1.079l.008.127c.062.535.518.951 1.07.95l8.892-.006-.005 8.873a1.078 1.078 0 1 0 2.157 0l.006-8.874 8.91-.006a1.078 1.078 0 1 0 0-2.157h.001l-8.91.005.007-8.928c0-.596-.483-1.079-1.078-1.079z" }));
}
